/* ARSHÉ V12 — NATIVE CENTER-SNAP CAROUSEL
   Touch scrolling is completely native. JS only manages the circular loop,
   active state, dots, size controls and arrow navigation.
*/
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.arsheV12Ready === '1') return;
    var track = root.querySelector('[data-carousel-track]');
    var originals = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-slide]'));
    var section = root.closest('.arshe-collection-v2') || root.parentElement;
    if (!track || originals.length < 2 || !section) return;

    root.dataset.arsheV12Ready = '1';
    var count = originals.length;
    var dots = section.querySelector('[data-carousel-dots]');
    var prev = section.querySelector('[data-carousel-prev]');
    var next = section.querySelector('[data-carousel-next]');
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-size-tab]'));
    var settleTimer = 0;
    var internalJump = false;
    var current = 0;

    /* Three sets create an invisible circular runway. */
    var before = document.createDocumentFragment();
    var after = document.createDocumentFragment();
    originals.forEach(function (slide) {
      var b = slide.cloneNode(true);
      var a = slide.cloneNode(true);
      b.dataset.arsheClone = 'before';
      a.dataset.arsheClone = 'after';
      before.appendChild(b);
      after.appendChild(a);
    });
    track.insertBefore(before, track.firstChild);
    track.appendChild(after);

    function slides() {
      return Array.prototype.slice.call(track.querySelectorAll('[data-carousel-slide]'));
    }

    function realIndex(i) {
      var r = (i - count) % count;
      return r < 0 ? r + count : r;
    }

    function centerLeft(slide) {
      if (!slide) return 0;
      return Math.max(0, slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2);
    }

    function nearestIndex() {
      var all = slides();
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = count;
      var distance = Infinity;
      all.forEach(function (slide, i) {
        var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        var d = Math.abs(slideCenter - center);
        if (d < distance) {
          distance = d;
          best = i;
        }
      });
      return best;
    }

    function updateUI(index) {
      var all = slides();
      current = realIndex(index);
      all.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-near-center', active);
        slide.setAttribute('aria-current', active ? 'true' : 'false');
        slide.dataset.realIndex = realIndex(i);
      });
      if (dots) {
        Array.prototype.forEach.call(dots.querySelectorAll('button'), function (dot, i) {
          var active = i === current;
          dot.classList.toggle('active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }
    }

    function jumpTo(index, smooth) {
      var all = slides();
      var slide = all[index];
      if (!slide) return;
      var left = centerLeft(slide);
      if (!smooth) {
        internalJump = true;
        track.scrollLeft = left;
        requestAnimationFrame(function () {
          internalJump = false;
          updateUI(index);
        });
      } else {
        track.scrollTo({ left: left, behavior: 'smooth' });
        updateUI(index);
      }
    }

    function go(real, smooth) {
      var normalized = ((real % count) + count) % count;
      jumpTo(count + normalized, smooth !== false);
    }

    function settle() {
      if (internalJump) return;
      var all = slides();
      if (!all.length) return;
      var index = nearestIndex();
      updateUI(index);

      /* If the native scroll reached a clone set, silently move to the
         identical card in the middle set. This is the circular loop. */
      if (index < count || index >= count * 2) {
        jumpTo(count + current, false);
        return;
      }

      /* Pixel-perfect final alignment. */
      var target = centerLeft(all[index]);
      if (Math.abs(track.scrollLeft - target) > 1) {
        jumpTo(index, true);
      }
    }

    function scheduleSettle(delay) {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, delay || 90);
    }

    function makeDots() {
      if (!dots) return;
      dots.innerHTML = '';
      originals.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'luxe-carousel__dot';
        dot.setAttribute('aria-label', 'View fragrance ' + (i + 1));
        dot.addEventListener('click', function () { go(i, true); });
        dots.appendChild(dot);
      });
    }

    function updateCard(card, size) {
      var suffix = size.replace('ml', '');
      var price = card.querySelector('.arshe-product-card__price');
      var id = card.getAttribute('data-v' + suffix + '-id');
      var url = card.getAttribute('data-v' + suffix + '-url') || card.getAttribute('data-product-url') || '#';
      if (price) price.textContent = card.getAttribute('data-v' + suffix + '-price') || '—';
      Array.prototype.forEach.call(card.querySelectorAll('.arshe-product-card__link,.arshe-product-card__media'), function (link) {
        link.href = url;
      });
      Array.prototype.forEach.call(card.querySelectorAll('[data-size-choice]'), function (button) {
        var bs = button.getAttribute('data-size-choice');
        var active = bs === size;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        button.disabled = !card.getAttribute('data-v' + bs.replace('ml', '') + '-id');
      });
      card.classList.toggle('is-unavailable-size', !id);
    }

    function setSize(size) {
      slides().forEach(function (card) { updateCard(card, size); });
      tabs.forEach(function (tab) {
        var active = tab.getAttribute('data-size-tab') === size;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    makeDots();
    setSize('30ml');

    if (prev) prev.addEventListener('click', function () { go(current - 1, true); });
    if (next) next.addEventListener('click', function () { go(current + 1, true); });
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { setSize(tab.getAttribute('data-size-tab')); });
    });

    /* Make the 30 ML / 50 ML controls on every fragrance card genuinely clickable.
       Selecting a size updates that card's active state, price and product URL. */
    function bindSizeChoices() {
      slides().forEach(function (card) {
        Array.prototype.forEach.call(card.querySelectorAll('[data-size-choice]'), function (button) {
          if (button.dataset.arsheSizeBound === '1') return;
          button.dataset.arsheSizeBound = '1';
          button.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            var size = button.getAttribute('data-size-choice');
            if (!card.getAttribute('data-v' + size.replace('ml', '') + '-id')) return;
            updateCard(card, size);
            Array.prototype.forEach.call(card.querySelectorAll('[data-size-choice]'), function (b) {
              var active = b.getAttribute('data-size-choice') === size;
              b.classList.toggle('is-active', active);
              b.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
          });
        });
      });
    }
    bindSizeChoices();

    /* Native touch/momentum scrolling. No pointermove, no preventDefault,
       no manual drag physics — this is what makes mobile swipe reliable. */
    track.addEventListener('scroll', function () {
      if (!internalJump) updateUI(nearestIndex());
      scheduleSettle(120);
    }, { passive: true });

    if ('onscrollend' in window) {
      track.addEventListener('scrollend', function () { settle(); }, { passive: true });
    }

    /* Mouse drag remains available on desktop without affecting touch. */
    var mouseDragging = false;
    var mouseStartX = 0;
    var mouseStartScroll = 0;
    track.addEventListener('mousedown', function (e) {
      if (e.button !== 0 || e.pointerType === 'touch') return;
      mouseDragging = true;
      mouseStartX = e.clientX;
      mouseStartScroll = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    window.addEventListener('mousemove', function (e) {
      if (!mouseDragging) return;
      track.scrollLeft = mouseStartScroll - (e.clientX - mouseStartX);
    });
    window.addEventListener('mouseup', function () {
      if (!mouseDragging) return;
      mouseDragging = false;
      track.classList.remove('is-dragging');
      settle();
    });

    function initial() {
      jumpTo(count, false);
      updateUI(count);
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(initial);
    });

    window.addEventListener('resize', function () {
      requestAnimationFrame(function () {
        jumpTo(count + current, false);
      });
    }, { passive: true });
  }

  function boot() {
    document.querySelectorAll('[data-arshe-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelectorAll) {
      e.target.querySelectorAll('[data-arshe-carousel]').forEach(init);
    }
  });
})();
